import { IJSendSuccessResponse } from "typings";
import { fetcher } from "utils";

type GetCategoriesRequest = () => Promise<IJSendSuccessResponse<{ payload: string[] }>>;

export const api__v1_get_userables_products_only_categories: GetCategoriesRequest = () => {
  return fetcher.get("/api/v1/userables/products/only_categories");
};
